<template>
  <el-dialog
    title="Đổi mật khẩu"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="password-form">
      <img style="margin: 0 auto; display: block" src="@/static/icon/changePw/image.svg" alt="">
      <div class="d-flex align-items-center justify-content-center" style="padding-top: 30px">
        <img src="@/static/icon/changePw/mk.svg" alt="">
        <span class="pl-2">Mật khẩu đã hết hạn</span>
      </div>
      <div  style="text-align: center; padding-top: 5px; line-height: 20px">
        <span>Mật khẩu đăng nhập hệ thống đã hết hạn</span> <br> <span>Vui lòng cập nhật mật khẩu mới để tiếp tục sử dụng</span>

      </div>
    </div>

    <div slot="footer" class="dialog-footer d-flex align-items-center justify-content-center">

      <el-button
        type="primary"
        class="btn-submit"
        :loading="loading"
        @click="submit()"
      >
        Đổi mật khẩu
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

  export default {
    name: 'ChangePasswordDialog',

    data() {
      return {
        dialogVisible: false,
        loading: false,
        form: {
          old_password: '',
          new_password: '',
          confirm_password: ''
        }
      }
    },

    methods: {
      open() {
        this.dialogVisible = true
      },

      handleClose() {
        this.form = {
          old_password: '',
          new_password: '',
          confirm_password: ''
        }
      },

      submit ()  {
        this.dialogVisible = false;
        this.$emit('changePW')
      },

    }
  }
</script>
<style scoped>
.password-form {
    padding: 8px 0;
}

.form-group {
    margin-bottom: 22px;
}

.form-label {
    display: block;
    margin-bottom: 8px;
    color: #1f2937;
    font-size: 14px;
    font-weight: 600;
}



/* Dialog */
::v-deep .el-dialog {
    border-radius: 16px;
    overflow: hidden;
}

::v-deep .el-dialog__header {
    padding: 24px;
    border-bottom: 1px solid #f1f5f9;
    display: none
}

::v-deep .el-dialog__title {
    font-size: 20px;
    font-weight: 700;
    color: #111827;
}

::v-deep .el-dialog__body {
    padding: 24px;
}

::v-deep .el-dialog__footer {
    padding: 20px 24px;
    border-top: 1px solid #f1f5f9;
}

/* Input */
::v-deep .el-input__inner {
    height: 48px;
    border-radius: 10px;
    border: 1px solid #dbe2ea;
    transition: all .2s;
    font-size: 14px;
}

::v-deep .el-input__inner:focus {
    border-color: #409eff;
}

/* Button */
.btn-cancel {
    height: 42px;
    min-width: 110px;
    border-radius: 10px;
}

.btn-submit {
    height: 42px;
    min-width: 140px;
    border-radius: 10px;
    font-weight: 600;
}

/* Header icon close */
::v-deep .el-dialog__headerbtn {
    top: 24px;
    right: 24px;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
    font-size: 18px;
    font-weight: 600;
}

/* Overlay */
::v-deep .v-modal {
    opacity: .6;
}
::v-deep .el-input__prefix {
    left: 10px;
    display: flex;
    align-items: center;
}

::v-deep .el-input__inner {
    padding-left: 40px !important;
    height: 48px;
    border-radius: 10px;
}
.password-note {
    margin-top: 16px;
    padding: 14px 16px;
    background: #fff8e6;
    border: 1px solid #ffe58f;
    border-radius: 10px;
}

.password-note-title {
    font-size: 14px;
    font-weight: 600;
    color: #d48806;
    margin-bottom: 8px;
}

.password-note ul {
    margin: 0;
    padding-left: 18px;
}

.password-note li {
    color: #595959;
    font-size: 13px;
    line-height: 24px;
}
</style>
